import React from "react";

const CryptoVIPLogo = ({ className = "h-10" }) => {
  return (
    <div className="flex items-center gap-2">
      {/* Logo Icon - Crown on dark rounded square */}
      <svg 
        viewBox="0 0 100 100" 
        className="w-7 h-7"
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Dark rounded square background with purple border */}
        <rect 
          x="5" 
          y="5" 
          width="90" 
          height="90" 
          rx="18" 
          fill="#1a1a1a" 
          stroke="#8B5CF6" 
          strokeWidth="2"
        />
        
        {/* Crown outline */}
        <path 
          d="M25 65 L25 40 L35 50 L50 30 L65 50 L75 40 L75 65" 
          stroke="#D4AF37" 
          strokeWidth="4" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          fill="none"
        />
        
        {/* Bottom line 1 */}
        <line 
          x1="25" 
          y1="72" 
          x2="75" 
          y2="72" 
          stroke="#D4AF37" 
          strokeWidth="4" 
          strokeLinecap="round"
        />
        
        {/* Bottom line 2 */}
        <line 
          x1="30" 
          y1="80" 
          x2="70" 
          y2="80" 
          stroke="#D4AF37" 
          strokeWidth="3" 
          strokeLinecap="round"
        />
      </svg>
      
      {/* Text with purple stroke */}
      <span 
        className="font-['Unbounded'] font-bold text-lg tracking-tight"
        style={{
          WebkitTextStroke: '0.5px #8B5CF6',
          paintOrder: 'stroke fill'
        }}
      >
        <span className="text-white">Crypto</span>
        <span className="text-[#D4AF37]">VIP</span>
        <span className="text-white">Club</span>
      </span>
    </div>
  );
};

export default CryptoVIPLogo;
